"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAmountFormatSelector = void 0;
/* eslint-disable functional/no-this-expression */
/*
 UI to select a unit and a number of decimals independently of each other
 */
var react_1 = require("react");
var uom_1 = require("uom");
function useAmountFormatSelector(options) {
    var selectedUnit = options.selectedUnit, selectedDecimalCount = options.selectedDecimalCount, onFormatChanged = options.onFormatChanged, onFormatCleared = options.onFormatCleared, unitsFormat = options.unitsFormat, units = options.units;
    var _a = react_1.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    // If there is no handler for onFormatChanged then the user should not be able to change the format
    if (!isOpen || !onFormatChanged) {
        var format = uom_1.UnitFormat.getUnitFormat(selectedUnit, unitsFormat);
        return {
            isOpen: isOpen,
            label: format ? format.label : "",
            showClearButton: false,
            getUnitItemProps: function () { return ({ value: "" }); },
            getPrecisionItemProps: function () { return ({ value: "" }); },
            unitItems: [],
            precisionItems: [],
            getLabelProps: function () { return ({
                onClick: function () { return setIsOpen(true); },
            }); },
            getUnitSelectProps: function () { return ({ onChange: function () { return ({}); }, value: "" }); },
            getPrecisionSelectProps: function () { return ({ onChange: function () { return ({}); }, value: "" }); },
            getClearButtonProps: function () { return ({ onClick: function () { return ({}); } }); },
            getCancelButtonProps: function () { return ({ onClick: function () { return ({}); } }); },
        };
    }
    // Get a list of all units within the quantity
    var quantityUnits = uom_1.UnitMap.getUnitsForQuantity(selectedUnit.quantity, units);
    var selectedUnitName = uom_1.Serialize.unitToString(selectedUnit);
    var unitItemValues = quantityUnits.map(function (u) { return uom_1.Serialize.unitToString(u); });
    var unitItems = quantityUnits.map(function (u) {
        var format = uom_1.UnitFormat.getUnitFormat(u, unitsFormat);
        return {
            label: format ? format.label : "",
        };
    });
    var precisionItemValues = [0, 1, 2, 3, 4, 5];
    if (precisionItemValues.indexOf(selectedDecimalCount) === -1) {
        precisionItemValues.push(selectedDecimalCount);
    }
    var precisionItems = precisionItemValues.map(function (dc) { return ({
        label: dc.toString(),
    }); });
    return {
        isOpen: isOpen,
        label: selectedUnitName,
        showClearButton: !!onFormatCleared,
        unitItems: unitItems,
        precisionItems: precisionItems,
        getUnitItemProps: function (index) {
            return {
                value: unitItemValues[index],
            };
        },
        getPrecisionItemProps: function (index) {
            var dc = precisionItemValues[index];
            return {
                value: dc.toString(),
            };
        },
        getLabelProps: function () { return ({ onClick: function () { return ({}); } }); },
        getUnitSelectProps: function () { return ({
            value: selectedUnitName,
            onChange: function (e) {
                setIsOpen(false);
                _onUnitChange(e, quantityUnits, unitItemValues, selectedDecimalCount, onFormatChanged);
            },
        }); },
        getPrecisionSelectProps: function () { return ({
            value: selectedDecimalCount.toString(),
            onChange: function (e) {
                setIsOpen(false);
                _onDecimalCountChange(e, selectedUnit, onFormatChanged);
            },
        }); },
        getClearButtonProps: function () { return ({
            onClick: function () {
                setIsOpen(false);
                if (onFormatCleared) {
                    onFormatCleared();
                }
            },
        }); },
        getCancelButtonProps: function () { return ({
            onClick: function () { return setIsOpen(false); },
        }); },
    };
}
exports.useAmountFormatSelector = useAmountFormatSelector;
function _onDecimalCountChange(e, selectedUnit, onFormatChanged) {
    onFormatChanged(selectedUnit, Number.parseInt(e.target.value, 10));
}
function _onUnitChange(e, units, unitItemValues, selectedDecimalCount, onFormatChanged) {
    var selectedIndex = unitItemValues.indexOf(e.target.value);
    var selectedUnit = units[selectedIndex];
    onFormatChanged(selectedUnit, selectedDecimalCount);
}
//# sourceMappingURL=use-amount-format-selector.js.map